import { Input } from 'antd-mobile'
import React, { useState, useEffect } from 'react'

import HCell from '../../HYBVant/HCell'

import './index.less'

const InputNumber: React.FC = (props: any) => {
  const { max, min, readed, precision = 0, onConfirm, format, ...rest } = props
  const [value, setValue] = useState('')
  const readonly = readed || rest?.disabled

  const handleChange = (event: any) => {
    const inputValue: any = event
    let newValue = parseFloat(inputValue)

    if (isNaN(newValue)) {
      if (inputValue === '') {
        setValue('')
        onConfirm?.('')
      }
      return
    }

    newValue = parseFloat(newValue.toFixed(precision))

    if (newValue < min) {
      newValue = min
    } else if (newValue > max) {
      newValue = max
    }
    if (format === 0.5) {
      // 确保值符合整数或整数+0.5的格式
      newValue = Math.round(newValue * 2) / 2
    }
    onConfirm?.(newValue.toString())
    setValue(newValue.toString())
  }

  useEffect(() => {
    handleChange(props?.value)
  }, [props?.value])
  return (
    <div className='input-number'>
      {readonly ? (
        <HCell value={value} readed={readonly} />
      ) : (
        <div className='input-number-container'>
          <Input type='number' value={value} onChange={handleChange} placeholder='请输入' />
          {props?.addonAfter && <div className='input-number-extra'>{props?.addonAfter}</div>}
        </div>
      )}
    </div>
  )
}

export default InputNumber
